{
  "adobeExperienceCloudNoOrgsSelect": "다른 조직 계정 선택",
  "help": "도움말",
  "newAnnouncement": "새로운 공지 있음",
  "notification": "알림 및 공지",
  "profile": "프로필",
  "searchButton": "검색",
  "sidenavMenuCloseTooltip": "메뉴 닫기",
  "sidenavMenuOpenTooltip": "메뉴 열기",
  "solutionSwitcher": "다른 솔루션으로 전환",
  "unread": "읽지 않은 알림"
}
